module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box info-box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-sm table-bordered table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("Total Income")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("₹")]), _vm._v(_vm._s(parseFloat(_vm.indInc + 0).toFixed(2)) + "/-")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Total Expense")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("₹")]), _vm._v(_vm._s(parseFloat(_vm.indExp + 0).toFixed(2)) + "/-")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title text-warning"
  }, [_vm._v("Profit-Loss")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b05886de!./~/vue-loader/lib/selector.js?type=template&index=0!./src/dashboard/ProfitLoss.vue
// module id = 919
// module chunks = 0